/* src/app/components/elibraryandcourse/exceleditor/exceleditor.component.scss */
:host {
  --review-primary: #253b80;
  --review-primary-dark: #1d2f68;
  --review-primary-soft: #eef2ff;
  --review-success: #16a34a;
  --review-success-soft: #ecfdf3;
  --review-danger: #dc2626;
  --review-danger-soft: #fef2f2;
  --review-warning: #d97706;
  --review-warning-soft: #fff7ed;
  --review-text: #172033;
  --review-text-secondary: #667085;
  --review-text-muted: #98a2b3;
  --review-border: #e4e7ec;
  --review-border-light: #edf0f4;
  --review-background: #f8fafc;
  --review-white: #ffffff;
  --review-radius: 12px;
}
:host ::ng-deep .document-review-dialog {
  border: 0;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.18), 0 8px 24px rgba(15, 23, 42, 0.08);
  background: var(--review-white);
}
:host ::ng-deep .document-review-dialog .p-dialog-header {
  padding: 0;
  border-bottom: 1px solid var(--review-border-light);
  background: var(--review-white);
}
:host ::ng-deep .document-review-dialog .p-dialog-content {
  padding: 0;
  background: var(--review-background);
  overflow: hidden;
}
:host ::ng-deep .document-review-dialog .p-dialog-footer {
  padding: 0;
  border-top: 1px solid var(--review-border);
  background: var(--review-white);
}
:host ::ng-deep .document-review-dialog .p-dialog-header-icons {
  position: absolute;
  top: 18px;
  right: 18px;
  z-index: 10;
}
:host ::ng-deep .document-review-dialog .p-dialog-header-icons .p-dialog-header-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  color: #667085;
  transition: all 0.2s ease;
}
:host ::ng-deep .document-review-dialog .p-dialog-header-icons .p-dialog-header-icon:hover {
  background: #f2f4f7;
  color: var(--review-text);
}
.review-dialog-header {
  min-height: 94px;
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 18px 70px 18px 24px;
  background:
    linear-gradient(
      135deg,
      #ffffff 0%,
      #fbfcff 100%);
}
.review-header-icon {
  width: 48px;
  height: 48px;
  flex: 0 0 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 13px;
  color: var(--review-primary);
  background: var(--review-primary-soft);
  font-size: 19px;
  box-shadow: inset 0 0 0 1px rgba(37, 59, 128, 0.08);
}
.review-header-content {
  min-width: 0;
  flex: 1;
}
.review-header-content h2 {
  margin: 0 0 4px;
  color: var(--review-text);
  font-size: 18px;
  line-height: 1.35;
  font-weight: 700;
  letter-spacing: -0.01em;
}
.review-header-content p {
  margin: 0;
  color: var(--review-text-secondary);
  font-size: 13px;
  line-height: 1.5;
}
.review-header-status {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 7px 11px;
  border: 1px solid #d9f2df;
  border-radius: 999px;
  background: var(--review-success-soft);
  color: #15803d;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}
.status-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--review-success);
  box-shadow: 0 0 0 3px rgba(22, 163, 74, 0.12);
}
.review-toolbar {
  min-height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 12px 20px;
  background: var(--review-white);
  border-bottom: 1px solid var(--review-border);
}
.toolbar-left {
  min-width: 0;
}
.toolbar-title {
  display: flex;
  align-items: center;
  gap: 12px;
}
.toolbar-title > i {
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #f2f4f7;
  color: var(--review-primary);
  font-size: 15px;
}
.toolbar-title > div {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.toolbar-title strong {
  color: var(--review-text);
  font-size: 14px;
  font-weight: 700;
}
.toolbar-title span {
  color: var(--review-text-muted);
  font-size: 12px;
}
.toolbar-right {
  display: flex;
  align-items: center;
  gap: 14px;
}
.toolbar-hint {
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--review-text-muted);
  font-size: 12px;
}
.toolbar-hint i {
  color: var(--review-warning);
}
.add-row-btn {
  height: 38px !important;
  border: 0 !important;
  border-radius: 9px !important;
  padding: 0 14px !important;
  background: var(--review-primary) !important;
  box-shadow: 0 3px 8px rgba(37, 59, 128, 0.16);
  font-size: 12px !important;
  font-weight: 600 !important;
  transition:
    background 0.2s ease,
    transform 0.2s ease,
    box-shadow 0.2s ease !important;
}
.add-row-btn:hover {
  background: var(--review-primary-dark) !important;
  transform: translateY(-1px);
  box-shadow: 0 5px 12px rgba(37, 59, 128, 0.22);
}
.add-row-btn:active {
  transform: translateY(0);
}
.excel-grid-container {
  height: calc(92vh - 225px);
  min-height: 300px;
  padding: 0;
  background: #f8fafc;
  overflow: hidden;
}
.grid-scroll-area {
  width: 100%;
  height: 100%;
  overflow: auto;
}
.scroll-bar {
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}
.scroll-bar::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.scroll-bar::-webkit-scrollbar-track {
  background: transparent;
}
.scroll-bar::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 20px;
}
.scroll-bar::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
:host ::ng-deep .review-data-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  min-width: 850px;
}
:host ::ng-deep .review-data-table .p-datatable-thead > tr > th {
  position: sticky;
  top: 0;
  z-index: 5;
  height: 48px;
  padding: 0 14px;
  border: 0;
  border-bottom: 1px solid #dfe3e8;
  background: #f8fafc;
  color: #475467;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.045em;
}
:host ::ng-deep .review-data-table .p-datatable-tbody > tr > td {
  height: 58px;
  padding: 0;
  border: 0;
  border-bottom: 1px solid var(--review-border-light);
  background: var(--review-white);
  vertical-align: middle;
}
:host ::ng-deep .review-data-table .p-datatable-tbody > tr:hover > td {
  background: #fbfcff;
}
.row-number-header {
  width: 58px;
  min-width: 58px;
  text-align: center !important;
  background: #f3f5f8 !important;
}
.title-header {
  width: 27%;
  min-width: 230px;
}
.content-header {
  min-width: 400px;
}
.action-header {
  width: 60px;
  min-width: 60px;
}
.table-header-content {
  display: flex;
  align-items: center;
  gap: 8px;
}
.table-header-content i {
  color: #667085;
  font-size: 12px;
}
.row-number-cell {
  width: 58px;
  min-width: 58px;
  text-align: center;
  background: #f8fafc !important;
  border-right: 1px solid var(--review-border-light) !important;
}
.row-number-cell span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 7px;
  color: #667085;
  background: #f1f3f6;
  font-size: 11px;
  font-weight: 600;
}
.title-cell,
.content-cell {
  position: relative;
  color: var(--review-text);
  font-size: 13px;
}
.editable-cell {
  cursor: text;
  transition: background 0.15s ease, box-shadow 0.15s ease;
}
.editable-cell:hover {
  background: #f8faff !important;
  box-shadow: inset 0 0 0 1px #dbe4ff;
}
.cell-output {
  min-height: 58px;
  display: flex;
  align-items: center;
  padding: 10px 14px;
  overflow: hidden;
}
.cell-output span {
  display: -webkit-box;
  max-width: 100%;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-height: 1.5;
  word-break: break-word;
}
.content-output {
  align-items: flex-start;
  padding-top: 12px;
  padding-bottom: 12px;
  color: #475467;
}
.empty-cell {
  color: #98a2b3 !important;
  font-style: italic;
}
.cell-editor-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 7px 9px;
  background: #f5f8ff;
  box-shadow: inset 0 0 0 2px var(--review-primary);
}
.content-editor {
  align-items: stretch;
}
.excel-cell-input,
.excel-cell-textarea {
  width: 100%;
  border: 1px solid #d0d5dd;
  border-radius: 7px;
  outline: none;
  padding: 9px 10px;
  color: var(--review-text);
  background: #ffffff;
  font-family: inherit;
  font-size: 13px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.excel-cell-input:focus,
.excel-cell-textarea:focus {
  border-color: var(--review-primary);
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.1);
}
.excel-cell-input::placeholder,
.excel-cell-textarea::placeholder {
  color: #98a2b3;
}
.excel-cell-input {
  height: 38px;
}
.excel-cell-textarea {
  min-height: 86px;
  resize: vertical;
  line-height: 1.5;
}
.special-row > td {
  background: #fafbfc !important;
}
.special-title-cell {
  padding: 0 14px !important;
  background: #f8fafc !important;
}
.special-label {
  display: flex;
  align-items: center;
  gap: 9px;
  color: #475467;
  font-size: 12px;
  font-weight: 700;
}
.special-icon {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #eef2f6;
  color: #667085;
  font-size: 11px;
}
.resources-content-cell {
  padding: 8px 12px !important;
  background: #fcfdff !important;
}
.resource-list {
  display: flex;
  flex-direction: column;
  gap: 7px;
  max-height: 170px;
  overflow-y: auto;
  padding-right: 4px;
}
.resource-item {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 52px;
  padding: 8px 10px;
  border: 1px solid #e6eaf0;
  border-radius: 9px;
  background: #ffffff;
  transition:
    border-color 0.2s ease,
    background 0.2s ease,
    transform 0.2s ease;
}
.resource-item:hover {
  border-color: #cbd5f5;
  background: #fafbff;
  transform: translateY(-1px);
}
.resource-icon {
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #eef2ff;
  color: var(--review-primary);
  font-size: 12px;
}
.resource-details {
  min-width: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.resource-title {
  color: var(--review-text);
  font-size: 12px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.resource-url {
  display: block;
  max-width: 100%;
  overflow: hidden;
  color: #667085;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-decoration: none;
}
.resource-url:hover {
  color: var(--review-primary);
  text-decoration: underline;
}
.resource-no-url {
  color: #98a2b3;
  font-size: 11px;
  font-style: italic;
}
.resource-open-btn {
  width: 30px;
  height: 30px;
  flex: 0 0 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  color: #667085;
  background: #f2f4f7;
  font-size: 11px;
  text-decoration: none;
  transition: all 0.2s ease;
}
.resource-open-btn:hover {
  color: var(--review-primary);
  background: var(--review-primary-soft);
}
.empty-resource {
  min-height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #98a2b3;
  font-size: 12px;
  font-style: italic;
}
.empty-resource i {
  font-size: 14px;
}
.action-cell {
  width: 60px;
  min-width: 60px;
  text-align: center;
}
.delete-row-btn {
  width: 32px !important;
  height: 32px !important;
  border: 0 !important;
  border-radius: 8px !important;
  background: transparent !important;
  color: #98a2b3 !important;
  opacity: 0;
  transition:
    opacity 0.2s ease,
    background 0.2s ease,
    color 0.2s ease !important;
}
.review-data-table .p-datatable-tbody > tr:hover .delete-row-btn {
  opacity: 1;
}
.review-data-table .p-datatable-tbody > tr:hover .delete-row-btn:hover {
  background: var(--review-danger-soft) !important;
  color: var(--review-danger) !important;
}
.review-state {
  height: 100%;
  min-height: 430px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px 24px;
  background: var(--review-background);
}
.loading-state {
  gap: 14px;
}
.loading-icon,
.state-icon {
  width: 68px;
  height: 68px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 18px;
  font-size: 26px;
}
.loading-icon {
  color: var(--review-primary);
  background: var(--review-primary-soft);
}
.state-icon {
  color: #667085;
  background: #eef2f6;
}
.error-state .state-icon {
  color: var(--review-danger);
  background: var(--review-danger-soft);
}
.loading-state :host ::ng-deep .review-spinner {
  width: 34px;
  height: 34px;
}
.loading-state :host ::ng-deep .review-spinner .p-progress-spinner-circle {
  stroke: var(--review-primary);
}
.state-content {
  max-width: 430px;
}
.state-content h3 {
  margin: 0 0 7px;
  color: var(--review-text);
  font-size: 16px;
  font-weight: 700;
}
.state-content p {
  margin: 0;
  color: var(--review-text-secondary);
  font-size: 13px;
  line-height: 1.6;
}
.error-state .state-content p {
  color: #b42318;
}
.review-footer {
  min-height: 68px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 12px 20px;
}
.footer-info {
  min-width: 0;
}
.footer-status {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #15803d;
  font-size: 12px;
  font-weight: 600;
}
.footer-status i {
  font-size: 14px;
}
.footer-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}
.cancel-btn {
  height: 38px !important;
  padding: 0 15px !important;
  border: 1px solid #d0d5dd !important;
  border-radius: 9px !important;
  background: #ffffff !important;
  color: #475467 !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  transition: all 0.2s ease !important;
}
.cancel-btn:hover {
  border-color: #98a2b3 !important;
  background: #f9fafb !important;
  color: #344054 !important;
}
.save-btn {
  min-width: 145px;
  height: 38px !important;
  padding: 0 16px !important;
  border: 0 !important;
  border-radius: 9px !important;
  background: var(--review-primary) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 10px rgba(37, 59, 128, 0.18);
  font-size: 12px !important;
  font-weight: 600 !important;
  transition:
    background 0.2s ease,
    transform 0.2s ease,
    box-shadow 0.2s ease !important;
}
.save-btn:hover:not(:disabled) {
  background: var(--review-primary-dark) !important;
  transform: translateY(-1px);
  box-shadow: 0 6px 14px rgba(37, 59, 128, 0.24);
}
.save-btn:active:not(:disabled) {
  transform: translateY(0);
}
.save-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  box-shadow: none;
}
@media (max-width: 900px) {
  .review-dialog-header {
    padding-right: 60px;
  }
  .review-header-status {
    display: none;
  }
  .toolbar-hint {
    display: none;
  }
  .excel-grid-container {
    height: calc(92vh - 215px);
  }
}
@media (max-width: 640px) {
  .review-dialog-header {
    min-height: 80px;
    padding: 14px 55px 14px 16px;
    gap: 10px;
  }
  .review-header-icon {
    width: 40px;
    height: 40px;
    flex-basis: 40px;
    border-radius: 10px;
    font-size: 16px;
  }
  .review-header-content h2 {
    font-size: 15px;
  }
  .review-header-content p {
    font-size: 11px;
  }
  .review-toolbar {
    padding: 10px 12px;
  }
  .toolbar-title > i {
    width: 34px;
    height: 34px;
  }
  .toolbar-title span {
    display: none;
  }
  .add-row-btn {
    width: 38px !important;
    min-width: 38px !important;
    padding: 0 !important;
  }
  .add-row-btn .p-button-label {
    display: none;
  }
  .review-footer {
    align-items: stretch;
    padding: 10px 12px;
  }
  .footer-info {
    display: none;
  }
  .footer-actions {
    width: 100%;
    justify-content: flex-end;
  }
  .cancel-btn,
  .save-btn {
    height: 36px !important;
  }
}
button:focus-visible,
a:focus-visible,
input:focus-visible,
textarea:focus-visible {
  outline: 3px solid rgba(37, 59, 128, 0.18);
  outline-offset: 2px;
}
/*# sourceMappingURL=exceleditor.component.css.map */
